import React from "react";
import { IconProps } from "../index";
import { colors } from "src/assets";

const Index: React.FC<IconProps> = ({ color, size }) => {
  const localWidth = size * (24 / 24);
  const localHeight = size * (21.051 / 24);
  const localColor = color || colors.white;
  return (
    <svg width={localWidth} height={localHeight} viewBox="0 0 24 21.051">
      <path
        d="M1.644,11.733H0L2.357,8.863l2.369,2.871H3.118a9.016,9.016,0,0,0,17.237,2.393.738.738,0,0,1,.957-.393.719.719,0,0,1,.4.942A10.486,10.486,0,0,1,1.644,11.733Zm9.623,3.905V11.247H6.806a.722.722,0,1,1,0-1.444h4.461V5.412a.733.733,0,0,1,1.467,0V9.8h4.461a.722.722,0,1,1,0,1.444H12.733v4.392a.733.733,0,0,1-1.467,0Zm8.007-6.322h1.609A9.016,9.016,0,0,0,3.645,6.924a.737.737,0,0,1-.957.393.718.718,0,0,1-.4-.942A10.42,10.42,0,0,1,11.955,0a10.4,10.4,0,0,1,10.4,9.317H24l-2.357,2.871Z"
        transform="translate(0 0)"
        fill={localColor}
      />
    </svg>
  );
};

export default Index;
